import { gql } from '@apollo/client';
import { ErrorMessageInfo, AccountInfoShared } from '@retainerclub/shared-api';

export default gql`
  mutation actionAccountPartnerLocationUpdate($input: AccountPartnerLocationUpdateActionInput!) {
    actionAccountPartnerLocationUpdate(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      previewData
      account {
        ...AccountInfoShared
      }
    }
  }
  ${ErrorMessageInfo}
  ${AccountInfoShared}
`;
